module.exports = __webpack_public_path__ + "static/img/service_safeguard_end_2.1a23df09.png";